module.exports = __webpack_public_path__ + "img/bth_bed_left_yaobu_sel.92235501.png";